const PRIVATE_ZOOPLUS_NET = 'private.zooplus.net';

export { PRIVATE_ZOOPLUS_NET };
//# sourceMappingURL=types.js.map
